import type { RouteObject } from 'react-router';
import { ImportPage } from './ImportPage';
import { ImportReviewPage } from './ImportReviewPage';

/**
 * Routes for the imports area (mounted inside RequireHousehold). They live
 * under /recipes because importing is how most recipes get created; react-router
 * ranks the static "import" segment above the sibling /recipes/:id route.
 */
export const importsRoutes: RouteObject[] = [
  { path: '/recipes/import', element: <ImportPage /> },
  { path: '/recipes/import/:jobId', element: <ImportReviewPage /> },
];
